import { useState, useEffect, useCallback } from 'react';
import { usePppApi } from '../services/pppApi';

export function useProcedimenti() {
  const api = usePppApi();
  const [procedimenti, setProcedimenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    setLoading(true);
    api.listProcedimenti({
      onSuccess: (data) => { setProcedimenti(data); setLoading(false); },
      onError:   (err)  => { setError(err); setLoading(false); },
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  return { procedimenti, loading, error, refresh: fetch };
}

export function useProcedimento(id) {
  const [procedimento, setProcedimento] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(async (silent = false) => {
    if (!id) return;
    if (!silent) setLoading(true);
    setError(null);
    try {
      const backend = window.VEDA_API_URL || process.env.REACT_APP_BACKEND_URL || '';
      const res = await window.fetch(`${backend}/api/v1/ppp/procedimenti/${id}`, {
        credentials: 'include',
        headers: { Accept: 'application/json' },
      });
      if (res.ok) {
        const data = await res.json();
        setProcedimento(data);
      } else {
        setError(res.status);
      }
    } catch (err) {
      setError('network');
    } finally {
      setLoading(false);
    }
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  return { procedimento, loading, error, refresh: fetch };
}

export function useRup() {
  const api = usePppApi();
  const [utentiRup, setUtentiRup] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.listUtentiRup({
      onSuccess: (data) => { setUtentiRup(data); setLoading(false); },
      onError:   ()     => setLoading(false),
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return { utentiRup, loading };
}

export function useProcedimentiAssegnati() {
  const api = usePppApi();
  const [procedimenti, setProcedimenti] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetch = useCallback(() => {
    setLoading(true);
    api.listProcedimentiAssegnati({
      onSuccess: (data) => { setProcedimenti(data); setLoading(false); },
      onError:   (err)  => { setError(err); setLoading(false); },
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  return { procedimenti, loading, error, refresh: fetch };
}

export function useScadenze(procedimentoId) {
  const api = usePppApi();
  const [scadenze, setScadenze] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetch = useCallback(() => {
    if (!procedimentoId) return;
    api.listScadenze(procedimentoId, {
      onSuccess: (data) => { setScadenze(data); setLoading(false); },
      onError:   ()     => setLoading(false),
    });
  }, [procedimentoId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => { fetch(); }, [fetch]);

  const scadenzeUrgenti = scadenze.filter((s) => s.giorniRimanenti <= 15 && s.stato !== 'scaduta' && s.stato !== 'rispettata');
  const scadenzeScadute = scadenze.filter((s) => s.stato === 'scaduta');

  return { scadenze, scadenzeUrgenti, scadenzeScadute, loading, refresh: fetch };
}
